import React, { useState } from "react";
import Navbar from "./Navbar";

const HouseDetail = {
  "House A": {
    "Building ID": "A123",
    "Building Height": "5.63",
    "Installation Cost": "41437.5",
    "Roof Area": "501.58072",
    "Panel Count": "175",
    "Roof Type": "Metal",
    "Yearly KwH": "1000",
  },
  "House B": {
    "Building ID": "B456",
    "Building Height": "6.63",
    "Installation Cost": "71437.5",
    "Roof Area": "651.58072",
    "Panel Count": "290",
    "Roof Type": "Metal",
    "Yearly KwH": "1000",
  },
  "House C": {
    "Building ID": "C789",
    "Building Height": "7.63",
    "Installation Cost": "91437.5",
    "Roof Area": "801.58072",
    "Panel Count": "375",
    "Roof Type": "Metal",
    "Yearly KwH": "1000",
  },
};

const checkpoints = [
  "Initial contact",
  "1st meeting",
  "Site visit",
  "Contract sent",
  "Contract signed",
  "Checks DNO, land reg, planning",
  "Planning application",
  "Planning approval",
  "PV Installer",
  "Operator agreement signed",
  "Install started",
  "Install completed",
];

const ProgressTracking = () => {
  const [selectedHouse, setSelectedHouse] = useState("");
  const [selectedBuildingID, setSelectedBuildingID] = useState("");
  const [updates, setUpdates] = useState({});
  const [checkpointsState, setCheckpointsState] = useState({});

  const houses = ["House A", "House B", "House C"];

  const handleHouseChange = (e) => {
    setSelectedHouse(e.target.value);
    setSelectedBuildingID(HouseDetail[e.target.value]["Building ID"]);
  };

  const handleCheckpointChange = (house, checkpoint, checked) => {
    setCheckpointsState((prevState) => ({
      ...prevState,
      [house]: {
        ...prevState[house],
        [checkpoint]: {
          ...prevState[house]?.[checkpoint],
          completed: checked,
        },
      },
    }));
  };

  const handleNoteChange = (house, checkpoint, note) => {
    setCheckpointsState((prevState) => ({
      ...prevState,
      [house]: {
        ...prevState[house],
        [checkpoint]: {
          ...prevState[house]?.[checkpoint],
          note,
        },
      },
    }));
  };

  const handleSave = () => {
    // Implement save logic here for all checkpoints
    console.log(`Saved all checkpoints for ${selectedHouse}`);
  };

  return (
    <div>
      <Navbar />
      <div className="flex flex-col justify-start items-center min-h-screen bg-gray-100 p-4 pt-2">
        <h1 className="text-4xl font-bold mb-4 text-gray-800">
          Progress Tracking
        </h1>
        <div className="flex flex-row justify-center items-start w-full max-w-4xl">
          <div className="bg-white shadow-md rounded-lg p-4 w-full max-w-md">
            <select
              value={selectedHouse}
              onChange={handleHouseChange}
              className="mb-2 p-2 border rounded w-full"
            >
              <option value="" disabled>
                Select House
              </option>
              {houses.map((house) => (
                <option key={house} value={house}>
                  {HouseDetail[house]["Building ID"]}
                </option>
              ))}
            </select>
            {selectedHouse && (
              <div className="bg-white shadow-md rounded-lg p-4 mt-4">
                <h2 className="text-xl font-semibold mb-2 text-gray-700">
                  {selectedHouse} Details
                </h2>
                <ul className="list-disc pl-5">
                  {Object.entries(HouseDetail[selectedHouse]).map(
                    ([key, value]) => (
                      <li key={key} className="mb-1">
                        <strong>{key}:</strong> {value}
                      </li>
                    )
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>
        {selectedBuildingID && (
          <div className="w-full max-w-2xl mt-4">
            <h2 className="text-2xl font-semibold mb-2 text-gray-700">
              Checkpoints for {selectedBuildingID}
            </h2>
            <div className="grid grid-cols-1 gap-4">
              {checkpoints.map((checkpoint) => (
                <div
                  key={checkpoint}
                  className="bg-white shadow-md rounded-lg p-4"
                >
                  <div className="flex items-center mb-2">
                    <input
                      type="checkbox"
                      checked={
                        checkpointsState[selectedHouse]?.[checkpoint]
                          ?.completed || false
                      }
                      onChange={(e) =>
                        handleCheckpointChange(
                          selectedHouse,
                          checkpoint,
                          e.target.checked
                        )
                      }
                      className="mr-2"
                    />
                    <span className="flex-grow">{checkpoint}</span>
                  </div>
                  <input
                    type="text"
                    value={
                      checkpointsState[selectedHouse]?.[checkpoint]?.note || ""
                    }
                    onChange={(e) =>
                      handleNoteChange(
                        selectedHouse,
                        checkpoint,
                        e.target.value
                      )
                    }
                    placeholder="Add note"
                    className="p-2 border rounded w-full"
                  />
                </div>
              ))}
            </div>
            <button
              onClick={handleSave}
              className="mt-4 p-2 bg-[#2d9376] text-white rounded"
            >
              Save All
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgressTracking;
